import { render, staticRenderFns } from "./NewGroupForm.vue?vue&type=template&id=2fdc33e6&scoped=true&"
import script from "./NewGroupForm.vue?vue&type=script&lang=ts&"
export * from "./NewGroupForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewGroupForm.vue?vue&type=style&index=0&id=2fdc33e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc33e6",
  null
  
)

export default component.exports